import { TabsActions } from '@mui/material';
import { LoadableNotification } from '@notifications/types';
import { createContext, Dispatch, RefObject, useContext } from 'react';

const NotificationsBoxContext = createContext<
    | {
          unreadNotificationsTotalCount: number;
          setUnreadNotificationsTotalCount: Dispatch<React.SetStateAction<number>>;
          isReadActionRunning: boolean;
          setIsReadActionRunning: Dispatch<React.SetStateAction<boolean>>;
          readNotificationsState?: [LoadableNotification[], Dispatch<React.SetStateAction<LoadableNotification[]>>];
          unreadNotificationsState?: [LoadableNotification[], Dispatch<React.SetStateAction<LoadableNotification[]>>];
          tabsActionRef?: RefObject<TabsActions | null>;
          isMarkAllReadLoading?: boolean;
          handleMarkAllAsRead?: () => Promise<void>;
          hasNotifications?: boolean;
          processedStreamIdsRef?: RefObject<Set<LoadableNotification['id']>>;
      }
    | undefined
>(undefined);

const useNotificationsBoxContext = () => {
    const context = useContext(NotificationsBoxContext);
    if (!context) {
        throw new Error('useNotificationsBoxContext must be used within a NotificationsBoxContext.Provider');
    }
    return context;
};

export { NotificationsBoxContext, useNotificationsBoxContext };
